// extracted by mini-css-extract-plugin
export default {"articles":"Articles_articles__u7A-Z","articles_list":"Articles_articles_list__PFnf5"};